export default __webpack_public_path__ + "static/timberline-aviation-large-9a5535e10ad9bb61c26a814a55132468.jpg";